module.exports = __webpack_public_path__ + "img/label_total.8b806bdf.png";